module.exports = __webpack_public_path__ + "static/img/2.d24d4a3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/gongzhumanghe/2.png
// module id = KO+M
// module chunks = 1